// 邮箱校验
export const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

// 1+个运单号校验
export const waybillsReg = /^SF(\d{10}|\d{13}[\s,，]?)([\s,，]SF(\d{10}|\d{13})[\s,，]?)*$/

// 1-10个运单号校验
export const waybill10Reg = /^SF(\d{10}|\d{13}[\s,，]?)([\s,，]SF(\d{10}|\d{13})[\s,，]?){0,9}$/
